export const canvasChangelogs = "/engagement/canvas/changelogs";
